















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { nation } from '@/data/nation';
/** 民族 */
@Component({})
export default class NationSelect extends Vue {
  @Prop() value: string;
  @Prop() disabled: boolean;
  innerValue: string | undefined = '';
  nationDataSource = nation;
  mounted() {
    this.innerValue = this.value;
  }

  onChange(value: string) {
    this.$emit('change', this.innerValue);
    this.$emit('input', this.innerValue);
  }
  @Watch('value')
  valueChange(v: string) {
    this.innerValue = v;
  }

  /** 自动补全组件 忽略大小写 */
  filterOption(input: any, option: any): any {
    return option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0;
  }
}
